import { useChatActions } from '@/features/ai-chat/state/useChat';

export function useNoMessagesScreen() {
  const { sendMessage } = useChatActions();
  return { sendMessage } as const;
}
